import '../scss/main.scss';
import { render, h } from 'preact';
import NewsFilterApp from './components/NewsFilterApp/NewsFilterApp';

const addQueryParamsToUrl = (url, queryParams) => {
	const urlInstance = new URL(url);
	const searchParams = urlInstance.searchParams;
	queryParams.forEach(queryParam => {
		searchParams.append(queryParam.key, queryParam.value);
	});
	return urlInstance.origin + urlInstance.pathname + '?' + searchParams.toString() + urlInstance.hash;
};

window.addEventListener('DOMContentLoaded', () => {
	let newsFilterContainers = document.querySelectorAll('.news-filter-container');

	if (newsFilterContainers.length < 1) {
		return;
	}

	newsFilterContainers = [].slice.call(newsFilterContainers);

	newsFilterContainers.forEach(container => {

		render(
			<NewsFilterApp
				fetchNewsItemsUrl={addQueryParamsToUrl(ajax_url_module_news_filter_get_newsitems, [{
					key: 'module-id',
					value: container.getAttribute('data-module-id')
				}])}
				fetchFiltersUrl={addQueryParamsToUrl(ajax_url_module_news_filter_get_newsfilters, [{
					key: 'module-id',
					value: container.getAttribute('data-module-id')
				}])}
			/>,
			container
		);
	});


});
